import { sharedState } from '../framework/state';
import { FrameworkFeature } from '../../common/framework/enumeration/FrameworkFeature';
import { ApplicationUserRole } from '../../common/application/enumeration/ApplicationUserRole';
import { NavigationItem } from '../framework/navigation/NavigationItem';
import { getAccessibleCustomers } from './service/resource_service';
import { Customer } from '../../common/application/model/Customer';

const customerNavigationItems: NavigationItem[] = [];
const customerNavigationMenu: NavigationItem = {
    icon: 'chart-donut',
    key: 'company',
    label: undefined,
    labelKey: 'nav.company',
    url: undefined,
    dividerBefore: false,
    get visible() {
        return (
            (sharedState.hasRole(ApplicationUserRole.MANAGER) || sharedState.admin) &&
            customerNavigationItems.length > 0
        );
    },
    children: customerNavigationItems,
};

export function setNavigationCustomer(customer: Customer) {
    (customerNavigationMenu as any).label = customer.name;
}

export async function registerApplicationNavigation() {
    sharedState.navigationStartMenus.unshift(customerNavigationMenu);

    sharedState.navigationEndMenus.unshift(
        {
            icon: 'database',
            key: 'configuration',
            label: undefined,
            labelKey: 'nav.configuration',
            url: undefined,
            dividerBefore: false,
            get visible() {
                return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
            },
            children: [
                {
                    icon: undefined,
                    key: 'accounts',
                    label: undefined,
                    labelKey: 'nav.accounts',
                    url: '/account',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'vendors',
                    label: undefined,
                    labelKey: 'nav.vendors',
                    url: '/vendor',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'vendor-locations',
                    label: undefined,
                    labelKey: 'nav.vendorLocations',
                    url: '/vendor-location',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'purchase-invoice-row-mappings',
                    label: undefined,
                    labelKey: 'nav.purchaseInvoiceRowMappings',
                    url: '/purchase-invoice-row-mapping',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'customers',
                    label: undefined,
                    labelKey: 'nav.customers',
                    url: '/customer',
                    dividerBefore: true,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'vehicle-contracts',
                    label: undefined,
                    labelKey: 'nav.vehicleContracts',
                    url: '/vehicle-contract',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'vendor-contracts',
                    label: undefined,
                    labelKey: 'nav.vendorContracts',
                    url: '/vendor-contract',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'netwheels-requests',
                    label: undefined,
                    labelKey: 'nav.netwheelsRequests',
                    url: '/netwheels-requests',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'sales-invoices',
                    label: undefined,
                    labelKey: 'nav.salesInvoices',
                    url: '/sales-invoice',
                    dividerBefore: true,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'retroactive-sales-invoices',
                    label: undefined,
                    labelKey: 'nav.retroactiveSalesInvoices',
                    url: '/retroactive-sales-invoice',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'purchase-invoices',
                    label: undefined,
                    labelKey: 'nav.purchaseInvoices',
                    url: '/purchase-invoice',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'finvoice-parser-patterns',
                    label: undefined,
                    labelKey: 'nav.finvoiceParserPatterns',
                    url: '/finvoice-parser-pattern',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'budget',
                    label: undefined,
                    labelKey: 'nav.budget',
                    url: '/budget',
                    dividerBefore: true,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'vehicle-cost-monthly-report',
                    label: undefined,
                    labelKey: 'nav.vehicleCostMonthlyReports',
                    url: '/vehicle-cost-monthly-report',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'task-list',
                    label: undefined,
                    labelKey: 'nav.taskList',
                    url: '/smart-fleet-task',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: 'view-dashboard-outline',
                    key: 'admin-dashboard',
                    label: undefined,
                    labelKey: 'title.dashboard',
                    url: '/dashboard',
                    dividerBefore: true,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: 'chart-box',
                    key: 'manager-reports',
                    label: undefined,
                    labelKey: 'title.reports',
                    url: '/reports',
                    dividerBefore: false,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: 'car-outline',
                    key: 'vehicle-makes',
                    label: undefined,
                    labelKey: 'title.vehicleMakes',
                    url: '/vehicle-make',
                    dividerBefore: true,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                {
                    icon: undefined,
                    key: 'vat-rates',
                    label: undefined,
                    labelKey: 'title.vatRates',
                    url: '/vat-rate',
                    dividerBefore: true,
                    get visible() {
                        return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API);
                    },
                    children: [],
                },
                // TODO: re-enable this when applicable
                // {
                //     icon: undefined,
                //     key: 'files',
                //     label: undefined,
                //     labelKey: 'nav.files',
                //     url: '/file',
                //     dividerBefore: true,
                //     get visible() { return sharedState.admin && sharedState.enabled(FrameworkFeature.ADMIN_API); },
                //     children: [],
                // }
            ],
        },
        {
            icon: 'bell-outline',
            unreadCount: 'incompleteTasks',
            key: 'notification-settings',
            label: undefined,
            labelKey: '',
            url: undefined,
            dividerBefore: false,
            get visible() {
                return (
                    (sharedState.hasRole(ApplicationUserRole.MANAGER) || sharedState.admin) &&
                    sharedState.enabled(FrameworkFeature.ADMIN_API)
                );
            },
            children: [
                {
                    icon: 'format-list-checks',
                    key: 'task-list',
                    label: undefined,
                    labelKey: 'nav.taskList',
                    url: '/smart-fleet-task',
                    dividerBefore: false,
                    get visible() {
                        return (
                            (sharedState.hasRole(ApplicationUserRole.MANAGER) || sharedState.admin) &&
                            sharedState.enabled(FrameworkFeature.ADMIN_API)
                        );
                    },
                    children: [],
                },
                {
                    icon: 'bell-outline',
                    key: 'notification-recipients',
                    label: undefined,
                    labelKey: 'nav.notificationRecipients',
                    url: '/notification-recipient',
                    dividerBefore: false,
                    get visible() {
                        return (
                            (sharedState.hasRole(ApplicationUserRole.MANAGER) || sharedState.admin) &&
                            sharedState.enabled(FrameworkFeature.ADMIN_API)
                        );
                    },
                    children: [],
                },
            ],
        },
    );

    customerNavigationItems.splice(0, customerNavigationItems.length);
    const customers = await getAccessibleCustomers();

    for (const customer of customers) {
        customerNavigationItems.push({
            icon: undefined,
            key: customer.id,
            label: customer.name,
            labelKey: undefined,
            url: `/dashboard/${customer.id}`,
            dividerBefore: false,
            get visible() {
                return sharedState.hasRole(ApplicationUserRole.MANAGER) || sharedState.admin;
            },
            children: [],
        });
    }
}
